module.exports = __webpack_public_path__ + "TG.png?4278556962c42d769095e32f8d017ca2";